import { styled } from "@styles";

export const Container = styled("main", {
  position: "relative",

  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",

  overflow: "hidden",

  padding: "0 8.75rem",

  width: "100%",
  height: "100svh",

  background: "$neutral00",

  fontStyle: "normal",
  color: "$neutral100",

  button: {
    marginTop: "2rem",
  },

  ".logo": {
    display: "flex",
    gap: 16,
    marginBottom: "4.125rem",
  },

  ".title": {
    fontSize: "2.625rem",
    fontWeight: "900",
    marginBottom: "1.5rem",
  },

  ".subtitle": {
    fontWeight: "700",
    fontSize: "1.5rem",
  },

  ".text": {
    fontWeight: "400",
    fontSize: "1.5rem",
    lineHeight: "2rem",
    margin: 0,
  },

  ".gray-text": {
    color: "$neutral30",
  },

  ".ilustration-404": {
    position: "relative",

    width: "31.25rem",
    height: "15.625rem",
  },

  "@lg": {
    padding: "4.125rem",

    ".ilustration-404": {
      width: "18.75rem",
      height: "15.625rem",
    },
  },

  "@md": {
    flexDirection: "column",
    justifyContent: "center",

    padding: "2rem",

    ".title": {
      fontSize: "2rem",
    },

    ".subtitle": {
      fontSize: "1rem",
    },

    ".text": {
      fontSize: "1rem",
      lineHeight: "1rem",
    },

    ".ilustration-404": {
      display: "none",
    },
  },
});

export const Ilustration = styled("div", {
  position: "absolute",
  width: "43.75rem",
  height: "43.75rem",
  bottom: -50,
  right: -100,

  "@lg": {
    width: "37.5rem",
    height: "37.5rem",
  },

  "@md": {
    width: "20rem",
    height: "20rem",
  },
});
